import { Col, Row } from 'react-bootstrap'

import { useTranslationRankmi } from 'helpers/translations.helper'
import BasePopover from '../BasePopover'
import { getPercentage } from '../CoursesTab/utils'

interface EvaluationProgressPopoverProps {
  progress: {
    approved: number
    reproved: number
  }
  total: number
  id?: string
  className?: string
  component?: React.ElementType
  popoverContent?: React.ReactNode
}

interface Label {
  label: React.ReactNode
  value: React.ReactNode
}

export const EvaluationProgressPopover: React.FC<EvaluationProgressPopoverProps> =
  ({
    progress,
    total,
    id = '',
    children,
    className,
    component: Component = 'div',
  }) => {
    const prefix = 'monitoring.attributes.evaluations'
    const t = useTranslationRankmi({ prefix })
    const { approved, reproved } = progress

    const percentages = {
      approved: getPercentage(approved, total),
      reproved: getPercentage(reproved, total),
    }

    const labels: Label[] = [
      { label: t('approved'), value: percentages.approved },
      { label: t('failed'), value: percentages.reproved },
      {
        label: t('inProcess'),
        value: 100 - (percentages.approved + percentages.reproved),
      },
    ]
    return (
      <BasePopover
        id={id}
        className={className}
        component={Component}
        popoverContent={
          <Row>
            {labels.map(({ label, value }, i) => (
              <Col xs={12} key={i}>
                <Row>
                  <Col xs={6}>{label} </Col>
                  <Col xs={6}>{value}%</Col>
                </Row>
              </Col>
            ))}
          </Row>
        }
      >
        {children}
      </BasePopover>
    )
  }

export default EvaluationProgressPopover
